import { atom } from 'jotai';
import { HomeRes } from '@/types/api/hall/home.d';

// 基础数据原子
export const homeDataAtom = atom<HomeRes | null>(null);

// 卡片数据原子, 需要在这里把数据格式化处理
// 数据格式化处理：
export const cardsAtom = atom(
  (get) => {
    const homeData = get(homeDataAtom);
    if (!homeData?.cards) return [];
    return homeData.cards.map(card => ({
      ...card,
      content: card.content ? (typeof card.content === 'string' ? JSON.parse(card.content) : card.content) : []
    }));
  }
);

// 根据类型获取特定卡片数据的原子
export const getCardByTypeAtom = atom(
  null,
  (get, _set, type: number) => {
    const cards = get(cardsAtom);
    return cards.find(card => card.type === type);
  }
);

// bannerDataAtom
export const bannerDataAtom = atom(
  (get) => {
    const homeData = get(homeDataAtom);
    if (!homeData?.top_banner) return [] as HomeRes['top_banner'];
    return homeData.top_banner as HomeRes['top_banner'];
  }
);

export const bottomBannerDataAtom = atom(
  (get) => {
    const homeData = get(homeDataAtom);
    if (!homeData?.bottom_banner) return [] as HomeRes['bottom_banner'];
    return homeData.bottom_banner as HomeRes['bottom_banner'];
  }
);

// 设置home数据的原子
export const setHomeDataAtom = atom(
  null,
  (_get, set, data: HomeRes) => {
    set(homeDataAtom, data);
  }
);

// 清空home数据的原子
export const clearHomeDataAtom = atom(
  null,
  (_get, set) => {
    set(homeDataAtom, null);
  }
);
